import {Component, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../../../../shared/services/api.service';
import {EnrollService} from '../../../../shared/services/enroll.service';
import {InitializeService} from 'src/app/shared/services/initialize.service';
import {LoaderService, NavigateService} from '@satoris/ngx-satoris';
import {removeStoredItem} from 'src/app/shared/utils/storage';

@Component({
  selector: 'app-activation-step-done',
  templateUrl: './activation-step-done.component.html',
  styleUrls: ['./activation-step-done.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivationStepDoneComponent{
  constructor(public api: ApiService,
    public enroll: EnrollService,
    private nav: NavigateService,
    private init: InitializeService,
    private loader: LoaderService) {
    if(!this.api.setCardRenewalMode && this.api.userInfo.nationalNumber && this.api.userRole.isCustomer) {
      this.api.setPrincipalMode = true;
    }
  }

  ngOnDestroy() {
    this.api.setPrincipalMode = false;
    if(this.api.setCardRenewalMode) {
      this.api.claims = {};
      this.api.isClaimsCached = false;
      this.api.deleteClaimsFromStorage().catch(err => {
        console.error('Failed to delete claims in ngOnDestroy:', err);
      });
      this.api.setCardRenewalMode = false;
      removeStoredItem('cardRenewalMode');
    }
  }

  private handleLogoutAllDevices(finalizeCallback: (isLogout: boolean) => void | Promise<void>) {
    this.loader.loading(true, {type: 'question', message: 'ask.logoutAllDevices', btnLabel: 'global.disconnect', custom: {closeBtnLabel: 'global.no'}}).then((userWantsLogout: boolean) => {
      if(userWantsLogout) {
        this.api.logoutAllDevices().then((isLogout: boolean) => {
          if(isLogout) {
            finalizeCallback(true);
          } else {
            this.loader.loading(true, {type: 'error', message: 'error.logoutAllDevices'})
              .then(() => finalizeCallback(false));
          }
        });
      } else {
        finalizeCallback(false);
      }
    });
  }

  private showLogoutSuccessMessage() {
    setTimeout(() => {
      this.loader.loading(true, {type: 'valid', message: 'success.logoutAllDevices'});
    }, 500);
  }

  done() {
    if(this.api.setCardRenewalMode) {
      const finaliseRenewal = (didLogout: boolean) => {
        this.api.claims = {};
        this.api.isClaimsCached = false;
        this.api.deleteClaimsFromStorage().then(() => {
          this.api.setCardRenewalMode = false;
          removeStoredItem('cardRenewalMode');
          this.nav.to('user');
          if(didLogout) {
            this.showLogoutSuccessMessage();
          }
        }).catch((err) => {
          console.error('Failed to delete claims from storage:', err);
          this.loader.loading(true, {type: 'warn', message: 'Claims cleanup failed. Please logout and login again to see updated claims.'});
          this.api.setCardRenewalMode = false;
          removeStoredItem('cardRenewalMode');
          this.nav.to('user');
        });
      };

      this.handleLogoutAllDevices(finaliseRenewal);

    } else if(this.api.setPrincipalMode) {
      const finalisePrincipal = (didLogout: boolean) => {
        this.loader.loading(true);
        this.api.info().then(() => {
          this.loader.loading(false);
          this.api.setPrincipalMode = false;
          this.nav.to('user');
          if(didLogout) {
            this.showLogoutSuccessMessage();
          }
        });
      };

      this.handleLogoutAllDevices(finalisePrincipal);

    } else {
      if(!this.api.userRole.isCustomer) {
        this.nav.to('user');
      } else {
        this.init.triggerSplashScreen('card.activating');
        setTimeout(() => {
          this.api.info().then(() => {
            this.nav.to('user');
          });
        }, 5000);
      }
    }
  }
}
